import React from "react";
import Skeleton from "../Skeleton/Skeleton";
import "./Chat.scss";

/**
 * Placeholder row for the conversations list (matches .conversation-item layout).
 */
function ConversationItemSkeleton() {
    return (
        <div
            className="conversation-item"
            style={{ cursor: "default", pointerEvents: "none" }}
            aria-hidden
        >
            <Skeleton width="58px" height="58px" borderRadius="50%" className="m-0 p-0" />
            <div className="conversation-info">
                <Skeleton width="160px" height="16px" borderRadius="8px" className="m-0 p-0" />
                <div className="conversation-details">
                    <Skeleton width="220px" height="14px" borderRadius="7px" className="m-0 p-0" />
                </div>
            </div>
        </div>
    );
}

export default ConversationItemSkeleton;
